var _circle, _circle2, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.254,
    cy: 10.9263,
    r: 4.92633,
    stroke: "#495057",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.7837,
    cy: 23.0556,
    r: 1.93356,
    stroke: "#495057",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4365 20.1719H9C6.79086 20.1719 5 21.9627 5 24.1719V26.0699",
    stroke: "#495057",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1857 23.0556C30.1857 22.7387 30.1425 22.4506 30.0992 22.148L31.7415 20.693L30.3009 18.2007L28.212 18.9066C27.751 18.5177 27.2324 18.2151 26.6562 17.9991L26.224 15.8525H23.3428L22.9106 17.9991C22.3343 18.2151 21.8157 18.5177 21.3547 18.9066L19.2658 18.2007L17.8252 20.693L19.4675 22.148C19.4243 22.4506 19.3811 22.7387 19.3811 23.0556C19.3811 23.3726 19.4243 23.6607 19.4675 23.9632L17.8252 25.4182L19.2658 27.9105L21.3547 27.2046C21.8157 27.5936 22.3343 27.8961 22.9106 28.1122L23.3428 30.2587H26.224L26.6562 28.1122C27.2324 27.8961 27.751 27.5936 28.212 27.2046L30.3009 27.9105L31.7415 25.4182L30.0992 23.9632C30.1425 23.6607 30.1857 23.3726 30.1857 23.0556Z",
    stroke: "#495057",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.9052ab86.svg";
export { ForwardRef as ReactComponent };